<div mat-dialog-title class="title">
    {{ data.header || 'INFO' }}
    <div class="pull-right close" (click)="close('close')">&#10005;</div>
</div>

<mat-dialog-content class="info-dialog-content">
    {{ data.message }}
</mat-dialog-content>

<div mat-dialog-actions class="pull-right {{ data.customClass }}">
    <button btn-primary class="custom-button" (click)="close('proceed')">{{ data.buttonText || 'OK' }}</button>
</div>
